import Spinner from "@legacy/core/components/Spinner";
import { Component } from "react";
import ButtonGroup from "../../core/buttons/ButtonGroup";
import ButtonGroupRow from "../../core/buttons/ButtonGroupRow";
import UniversalButton from "../../core/buttons/UniversalButton";
import Banner from "../../core/components/Banner";
import BasicDisplayField from "../../core/fields/BasicDisplayField";
import TextField from "../../core/fields/TextField";


class VendorCreditVoidForm extends Component {

    componentDidMount() {
        // Return to the previous scroll
        document.querySelector(".main").scrollTo(0, this.props.returnScroll || 0)
    }

    renderButtons = () => {
        const { requestAction, switchToPrimaryForm, submitting, errors } = this.props

        if (errors.unexpectedError) {
            return (
                <div className="data-panel__action-feedback">
                    <span className="text-invalid"><strong>An unexpected error occurred.</strong></span>
                </div>
            )
        }
        else {
            if (submitting) {
                return <Spinner centered={true} />
            }
            else {
                return (
                    <ButtonGroup>
                        <ButtonGroupRow>
                            <UniversalButton type="danger" text="Void" handler={event => requestAction("VENDOR_CREDIT_VOID_SUBMIT")} />
                            <UniversalButton type="secondary" text="Cancel" handler={event => switchToPrimaryForm()} />
                        </ButtonGroupRow>
                    </ButtonGroup>
                )
            }
        }
    }

    render() {
        const { vendorCredit, voidData, errors, onFormDataChange, inventoryReturned } = this.props

        return (
            <div className="data-panel-container data-panel-container--with-margin">
                <div className="data-panel" aria-label="Vendor Credit Void">
                    <div className="data-panel__form" aria-label="Vendor Credit Void Form">
                        <p className="data-panel__form__caption">Please confirm that you'd like to void this vendor credit.</p>
                        <BasicDisplayField
                            fieldName="id"
                            fieldLabel="Roopairs Vendor Credit ID"
                            fieldValue={vendorCredit.custom_id ? vendorCredit.custom_id : vendorCredit.id}
                        ></BasicDisplayField>
                        <TextField
                            fieldName="void_message"
                            fieldLabel="Void Reason"
                            fieldValue={voidData.void_message || ""}
                            fieldOnChange={void_message => onFormDataChange("void_message", void_message || "")}
                            rows={3}
                            placeholder="Why are you voiding this vendor credit?"
                            errors={errors}
                        ></TextField>
                        {
                            vendorCredit.applications.length !== 0 && (
                                <Banner type="warning" text="This vendor credit is applied to bills. Voiding will take it off those bills and restore what they owe." />
                            )
                        }
                        {
                            inventoryReturned && (
                                <Banner type="warning" text="Parts on this vendor credit were removed from inventory. Voiding will put them back in stock." />
                            )
                        }
                    </div>
                    {this.renderButtons()}
                </div>
            </div>
        )
    }
}

export default VendorCreditVoidForm;
